import { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import images from "../../../assets/images/constantImages";
import { getCategoryDetails } from "../Items/CategorySlice";
import { formatRupees } from "../../Common/ApiCommon/ApiService";

const useAddStock = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  // Get data from Redux
  const {
    data: categories = [], loading, error,
  } = useSelector((state) => state.categories);

  // Fetch category details on mount
  useEffect(() => {
    dispatch(getCategoryDetails("stock_list=true"));
  }, [dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-nowrap">{value}</div>,
      },
      { Header: "Categories", accessor: "name" },
      {
        Header: "Product",
        accessor: "items",
        headerAlign: "text-left",
        cellAlign: "text-center",
        Cell: ({ value }) => (
          <ul className="flex flex-col items-start pl-5">
            {value?.map((item, index) => (
              <li key={index} className="list-disc text-left">
                {item.name}
              </li>
            ))}
          </ul>
        ),
      },
      {
        Header: "Price",
        accessor: "product_price",
        Cell: ({ row }) => (
          <div>
            {row.original.items?.map((item, index) => (
              <div key={index}>{formatRupees(item.price)}</div>
            ))}
          </div>
        ),
      },
      {
        Header: "Quantity",
        accessor: "product_quantity",
        Cell: ({ row }) => (
          <div>
            {row.original.items?.map((item, index) => (
              <div key={index}>{item.stock_quantity}</div>
            ))}
          </div>
        ),
      },
      {
        Header: "Meal Type",
        accessor: "meal_type",
        Cell: ({ row }) => (
          <div>
            {row.original.items?.map((item, index) => (
              <div key={index}>{item.meal_type}</div>
            ))}
          </div>
        ),
      },
      // {
      //   Header: "Stock",
      //   accessor: "stock_available",
      //   Cell: ({ row }) => (
      //     <div>
      //       {row.original.items?.map((item, index) => {
      //         const isInStock = item.stock_available;
      //         return (
      //           <div
      //             key={index}
      //             className="mb-1 flex flex-col items-start lg:items-center"
      //           >
      //             <img
      //               src={
      //                 isInStock ? images.ontogleswitch : images.offtogleswitch
      //               }
      //               alt="Stock Toggle"
      //               className="w-12 h-6 object-contain"
      //             />
      //           </div>
      //         );
      //       })}
      //     </div>
      //   ),
      // },
      { Header: "Missing", accessor: "missing" },
      { Header: "Loss", accessor: "loss" },
    ],
    []
  );

  const data = categories || [];

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

  const handlePageChange = (newPage) => setCurrentPage(newPage);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  return {
    columns,
    currentRows,
    totalRows: data.length,
    currentPage,
    rowsPerPage,
    loading,
    error,
    handlePageChange,
    handleRowsPerPageChange,
  };
};

export default useAddStock;
